<template>
  <article class="records-cont">
    <div class="checkout-box" v-show="retailMenu">
      <cell title="零售出库" is-link class="content" :link="`/auction/carmanage/outbound/retail/${carId}`">
        <img slot="icon" class="icon" src="../../stylesheets/images/lsck@2x.png">
      </cell>
    </div>
    <div class="checkout-box" v-show="otherMenu">
      <cell title="其他批售出库" is-link class="content" :link="`/auction/carmanage/outbound/batch_sale/${carId}`">
        <img slot="icon" class="icon" src="../../stylesheets/images/psck@2x.png">
      </cell>
    </div>
    <div class="checkout-box" v-show="scrappedMenu">
      <cell title="报废出库" is-link class="content" :link="`/auction/carmanage/outbound/scrap/${carId}`">
        <img slot="icon" class="icon" src="../../stylesheets/images/bfck@2x.png">
      </cell>
    </div>
    <div class="checkout-box">
      <cell title="特殊出库" is-link class="content" :link="`/auction/carmanage/outbound/special/${carId}`">
        <img slot="icon" class="icon" src="../../stylesheets/images/spck@2x.png">
      </cell>
    </div>

    <div class="records-desc">
      <p class="tips">操作非“立新车市”出库车辆时，请注意：</p>
      <div v-if="retailMenu">
        <p>【零售出库】</p>
        <p>需符合二手车部对零售车辆的管控要求。</p>
        <br/>
      </div>
      <div v-if="otherMenu">
        <p>【其他批售出库】</p>
        <p>需符合二手车部对其他批售车辆的管控要求。非零售车辆，必须经过立新车市竞拍环节，流拍后及流拍后撮合未成功的车辆可以选择“其他批售出库”方式。</p>
        <p>注意：如已产生拍卖出价的车辆，须与出价车商撮合以撮合方式出库，而不能以“其他批售出库”方式出库。</p>
        <br/>
      </div>
      <div v-if="scrappedMenu">
        <p>【报废出库】</p>
        <p>需符合报废车辆要求的车辆。</p>
        <br/>
      </div>
      <div>
        <p>【特殊出库】</p>
        <p>包括但不限于以下情形的车辆可以特殊出库：</p>
        <p>a.尚未实现销售的寄售车辆，车主提出提前解除寄售关系的；</p>
        <p>b.因特殊原因没有在立新车市平台竞拍的他品牌车辆；</p>
        <p>c.其他特殊情况。</p>
        <br/>
      </div>
    </div>
  </article>
</template>

<script>
import { Cell } from '@lx-frontend/cvux'

export default {
  components: {
    Cell
  },
  data () {
    return {
      carId: '',
      retailMenu: false,
      otherMenu: false,
      scrappedMenu: false
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      const id = this.$route.params.id
      this.carId = id
      this.$rest.outBound.getMenu(null, id).then(res => {
        if (res.code === 0) {
          this.carId = res.data.id
          this.retailMenu = res.data.retail_menu
          this.otherMenu = res.data.other_menu
          this.scrappedMenu = res.data.scrapped_menu
        } else {
          this.showToast(res.message)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.records-cont{
  padding: 0 .3rem;
  box-sizing: border-box;
  .item {
    margin-top: .38rem;
  }
  .records-desc{
    .tips{
      color: #fb3f3f;
      padding-top: .41rem;
      padding-bottom: .21rem;
    }
    color: #999999;
    font-size: 13px;
    line-height: 1.3;
  }

  .checkout-box {
    background: #fff;
    // width: 6.9rem;
    height: 2.67rem;
    border-radius: .08rem;
    margin-top: .4rem;
    .content {
      height: 100%;
      line-height: 4.3;
      box-sizing: border-box;
      font-size: .4rem;
      .icon {
        display: block;
        margin-right: .7rem;
        width: 1.3rem;
      }
    }
  }
}
</style>
